import React from 'react'

const Loader = () => {
  return (
    <div className='loader-div'>
      <span class="loader"></span>
    </div>
  )
}

export default Loader